import axios from './providers/axios';

/**
 * EL-802 — Analitik panosu (program huni / adım süresi / yanlış cevap / trivia) servisleri.
 * Backend: /v3/admin/analytics/*
 */
const buildQuery = (params = {}) => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== null && value !== undefined && value !== '' && value !== 'all')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    return query ? `?${query}` : '';
};

const analyticsService = {
    /** Adım bazında kaç kişi geldi / geçti / kaldı. */
    getProgramFunnel(params) {
        return axios.get(`/v3/admin/analytics/program/funnel${buildQuery(params)}`);
    },

    /** Adım / modül bazında yaklaşık geçirilen süre. */
    getProgramStepDuration(params) {
        return axios.get(`/v3/admin/analytics/program/stepDuration${buildQuery(params)}`);
    },

    /** Program sorularında yanlış cevaplar (doğru cevabı işaretlenmiş sorular). */
    getProgramWrongAnswers(params) {
        return axios.get(`/v3/admin/analytics/program/wrongAnswers${buildQuery(params)}`);
    },

    /** Şirketin trivia sınavları (filtre kutusu). */
    getTriviaExams() {
        return axios.get('/v3/admin/analytics/trivia/exams');
    },

    /** Trivia yanlış soru raporu (soru + kişi bazlı). */
    getTriviaWrongAnswers(params) {
        return axios.get(`/v3/admin/analytics/trivia/wrongAnswers${buildQuery(params)}`);
    },
};

export default analyticsService;
